import { createLogger, format, transports } from 'winston';
import { LEVEL, MESSAGE } from 'triple-beam';
import { noLint_console, noLint_stringify, noLint_getColor } from '../woLint/utils/logger'; // note: for some reason during the global setup and teardown scripts, the "@" notation doesn't work

const { combine, printf } = format;

const outputFormat = printf(({ level, message, label, timestamp }) => {
  let color;
  if (level === 'debug') color = noLint_getColor('green');
  else if (level === 'info') color = noLint_getColor('yellow');
  else if (level === 'error') color = noLint_getColor('red');
  else color = noLint_getColor('magenta');

  const grey = noLint_getColor('grey');

  const messageJson = noLint_stringify(message);

  return `${grey(`${timestamp} [${label}] ${level}:`)} ${color(messageJson || message)}`;
});

const transportInstance = new transports.Console({});
if (process.env.NODE_ENV !== 'test') {
  transportInstance.log = (info, callback: () => void) => {
    transportInstance.emit('logged', info[MESSAGE]);
    noLint_console(info[LEVEL], info[MESSAGE]);
    if (callback) callback();
  };
}

export const logger = createLogger({
  level: process.env.NODE_ENV === 'production' ? 'info' : 'debug',
  format: combine(format.timestamp(), outputFormat),
  transports: [transportInstance],
});
